import type {ReactNode} from 'react'
import styles from './SidebarSection.module.css'

interface SidebarSectionProps {
  title: string
  /**
   * Optional custom header that fully replaces the default static `<h4>` header.
   * Use for interactive section headers (e.g. a clickable disclosure row). A custom
   * header must occupy the same header height as the default so the title-to-body
   * spacing stays uniform across sections.
   */
  header?: ReactNode
  children?: ReactNode
}

/** Reusable sidebar metadata section (Assignees, Labels, etc.) */
export function SidebarSection({title, header, children}: SidebarSectionProps) {
  return (
    <section aria-label={title}>
      {header ?? (
        <div className={styles.header}>
          <h4 className={styles.sectionTitle}>{title}</h4>
        </div>
      )}
      <div className={styles.body}>
        {children ?? <p className={styles.emptyState}>None yet - feature coming soon</p>}
      </div>
    </section>
  )
}
